import Handlebars from "handlebars";
import AuthService from "./auth-service";
import CallService from "./call-service";

class UIService {
    initialized = false;
    _delegationReady = false;

    init = async () => {
        this.setupEventDelegation();

        // ConnectyCube is only relevant once a user is signed in, and only on screens that
        // actually render the calling UI (the call modal is only rendered for signed-in users —
        // see app/views/shared/_call_modal.html.erb). Public pages must never call
        // AuthService.login(), which would POST /api/v1/connectycube/session for anonymous
        // visitors and crash on a null credentials response.
        const signedIn = document.body?.dataset?.signedIn === "true";
        const hasCallScreen = !!document.getElementById("call");
        if (!signedIn || !hasCallScreen) return;

        const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;
        if (!csrfToken) return;

        try {
            const credentials = await AuthService.login();
            if (!credentials?.user_id) {
                return;
            }

            if (!this.initialized) {
                CallService.init({
                    id: credentials.user_id,
                    password: credentials.password
                });
                this.initialized = true;
            }
        } catch (error) {
            if (!error.isUnauthorized) {
                console.log("[UIService] ConnectyCube initialization skipped:", error.message);
            }
        }
    };

    setupEventDelegation = () => {
        if (this._delegationReady) return;
        this._delegationReady = true;

        const actions = {
            "call-start-audio": () => CallService.startAudioCall(),
            "call-start-video": () => CallService.startVideoCall(),
            "videochat-stop-call": () => CallService.stopCall(),
            "videochat-mute-unmute": () => CallService.setAudioMute(),
            "videochat-switch-camera": () => CallService.switchCamera(),
            "videochat-sharing-screen": () => CallService.sharingScreen(),
        };

        document.addEventListener("click", (event) => {
            for (const [id, handler] of Object.entries(actions)) {
                if (event.target.closest(`#${id}`)) {
                    handler();
                    return;
                }
            }
        });
    };
}

// create instance
const UI = new UIService();

export default UI;
